/**
 * Captures a chart DOM element as an image and adds it to a jsPDF document.
 * Uses html2canvas to render the element, then embeds as PNG.
 */
export async function addChartToPDF(doc, chartRef, { title, startY = 22 } = {}) {
  if (!chartRef?.current) return startY

  const { default: html2canvas } = await import('html2canvas')

  const canvas = await html2canvas(chartRef.current, {
    backgroundColor: '#ffffff',
    scale: 2,
    logging: false,
    useCORS: true,
  })

  const imgData = canvas.toDataURL('image/png')
  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const margin = 14
  const maxWidth = pageWidth - margin * 2

  // Scale image to fit page width
  const imgWidth = maxWidth
  const imgHeight = (canvas.height / canvas.width) * imgWidth

  doc.addPage()
  let y = margin

  if (title) {
    doc.setFontSize(16)
    doc.setTextColor(0)
    doc.text(title, margin, y + 8)
    y += 16
  }

  // If image is too tall, scale it down to fit
  const availableHeight = pageHeight - y - margin
  const finalHeight = Math.min(imgHeight, availableHeight)
  const finalWidth = (finalHeight / imgHeight) * imgWidth

  doc.addImage(imgData, 'PNG', margin, y, finalWidth, finalHeight)

  return y + finalHeight + 10
}
